import platformUtils from '../privates/platformUtils'; //eslint-disable-line no-unused-vars
import monitoring from '../privates/monitoring';

platformUtils.setExperiments(self.openExperiments);
platformUtils.initMonitoringServices(self.monitoringServices);
monitoring.initRaven();
